<script setup>
// Components
import { computed } from 'vue';
import FormNewsletter from '../Form/FormNewsletter.vue';
import AddOnLabel from '@/Components/AddOnLabel.vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
    title: String,
    text: String,
    addOnLabel: Boolean,
});

const moduleActive = computed(() => usePage().props.template_options.modules.newsletter_active);
</script>

<template>
    <div class="bg-gray-lighter" v-if="moduleActive && title">
        <div class="container py-12 md:py-16" :class="{ relative: addOnLabel }">
            <AddOnLabel v-if="addOnLabel" />

            <div class="flex flex-col items-center">
                <h2 class="mb-4 " v-html="title" v-if="title"></h2>
                <div v-if="text" v-html="text" class="prose text-center"></div>

                <FormNewsletter />
            </div>
        </div>
    </div>
</template>
